import { render } from "./accesories.vue?vue&type=template&id=49752615&scoped=true"
import script from "./accesories.vue?vue&type=script&lang=js"
export * from "./accesories.vue?vue&type=script&lang=js"

import "./accesories.vue?vue&type=style&index=0&id=49752615&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49752615"]])

export default __exports__